import React from 'react';
import PatientQueue from './PatientQueue';

const DischargeManagement = () =>
    <PatientQueue
        showQueueCount
        patientDetailColumn
        providerDetailColumn
        diagApcmProgramDetail
        urgentColumn
        todoItemColumn
        showFilters
        showProgramTypeFilter
        chartColumn
        lastWorkedByColumn
        rowHeight={150}
        page
        queue="urgentDischargeManagement"
        endpoint="Urgent?typesToInclude=25"
        label="Urgent - Discharge Management"
    />;

export default DischargeManagement;
